import { createAction, props } from '@ngrx/store';
import { AchievementManagementDetails } from '../../interface/achievements';

export const selectAchievement = createAction(
  '[Achievements Details] Select Achievement',
  props<{ achievementId: number }>()
);

export const updateAchievements = createAction(
  '[Achievements Details] Update Achievement',
  props<{ achievements: AchievementManagementDetails[] }>()
);
